var map = {
	"./music-instructions.json": 4668,
	"./music-library-intro2024.json": 4669,
	"./music-library-launch2024.json": 4670,
	"./music-progression.json": 4671,
	"./startSourcesAdvanced.json": 4672,
	"./startSourcesSimple.json": 4673,
	"./startSourcesSimple2.json": 4674,
	"./startSourcesTracks.json": 4675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4446;